require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-5-easy-ways-to-increase-repeat-orders-on-your-ecommerce-store.json") })
        }
      }, "path---blog-5-easy-ways-to-increase-repeat-orders-on-your-ecommerce-store");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-5-easy-ways-to-increase-repeat-orders-on-your-ecommerce-store!./.cache/json/blog-5-easy-ways-to-increase-repeat-orders-on-your-ecommerce-store.json
// module id = 402
// module chunks = 231608221292675